import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "desktop-confirm-section" }
const _hoisted_2 = { class: "desktop-confirm-header" }
const _hoisted_3 = { class: "desktop-confirm-title" }
const _hoisted_4 = {
  key: 0,
  class: "desktop-no-entries"
}
const _hoisted_5 = {
  key: 1,
  class: "desktop-lines-section"
}
const _hoisted_6 = { class: "desktop-lines-header" }
const _hoisted_7 = { class: "desktop-lines-list" }
const _hoisted_8 = { class: "desktop-line-content" }
const _hoisted_9 = { class: "desktop-line-balls" }
const _hoisted_10 = {
  key: 0,
  class: "desktop-line-color-bonus"
}
const _hoisted_11 = { class: "desktop-line-color-bonus-text" }
const _hoisted_12 = {
  key: 1,
  class: "desktop-line-bonus"
}
const _hoisted_13 = { class: "desktop-line-bonus-ball" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["disabled"]


import { getColorComboLineBonusLabel } from '@/constants/standardBetPlusColorBonus';
import type { BallColorSlug } from '@/constants/sameColorBalls';

interface Line {
  numbers: number[];
  bonus?: number;
  bonusColor?: BallColorSlug;
  numBets: number;
  picks: number;
  market?: {
    label?: string;
    odds?: number;
    market?: {
      slug?: string;
    };
    marketGroup?: {
      group_id: number;
      name: string;
      slug: string;
    };
    market_slug?: string;
  };
}

interface Props {
  lines: Line[];
  currentGameSlug?: string;
  selectedRelatedGames?: string[];
  isProcessing?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'DesktopConfirmSection',
},
  __name: 'DesktopConfirmSection',
  props: {
    lines: { default: () => [] },
    currentGameSlug: { default: '' },
    selectedRelatedGames: { default: () => [] },
    isProcessing: { type: Boolean, default: false }
  },
  emits: [
  'clear-all',
  'remove-line',
  'add-to-betslip',
  'update:selectedRelatedGames',
],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const removeLine = (index: number) => {
  emit('remove-line', index);
};

const clearAll = () => {
  emit('clear-all');
};

const addToBetslip = () => {
  emit('add-to-betslip', props.lines);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('detail.confirmEntries')), 1)
    ]),
    (_ctx.lines.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('detail.noEntriesSelected')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('detail.selectedLines', { count: _ctx.lines.length })), 1),
            _createElementVNode("button", {
              class: "desktop-clear-btn",
              onClick: clearAll
            }, _toDisplayString(_ctx.$t('common.clearAll')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "desktop-line-item"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.numbers, (number) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: number,
                        class: "desktop-line-ball"
                      }, _toDisplayString(number), 1))
                    }), 128)),
                    (_unref(getColorComboLineBonusLabel)(line))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "desktop-line-bonus-separator" }, "+", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getColorComboLineBonusLabel)(line)), 1)
                        ]))
                      : (line.bonus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "desktop-line-bonus-separator" }, "+", -1)),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(line.bonus), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", {
                  class: "desktop-remove-line-btn",
                  onClick: ($event: any) => (removeLine(index))
                }, " × ", 8, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "desktop-add-to-betslip-btn",
            disabled: _ctx.lines.length === 0 || _ctx.isProcessing,
            onClick: addToBetslip
          }, _toDisplayString(_ctx.$t('detail.addToBetslip')), 9, _hoisted_15)
        ]))
  ]))
}
}

})